import { filter, get, includes, isEmpty, isEqual, keys, map } from 'lodash'

const eventDifference = (
  original,
  changes,
  nameProp = 'name',
  omitProps = [],
) =>
  map(
    filter(keys(original), key =>
      !isEmpty(omitProps)
        ? !includes(omitProps, key) &&
          !isEqual(get(original, key), get(changes, key))
        : !isEqual(get(original, key), get(changes, key)),
    ),
    differentKey => ({
      name: get(original, nameProp),
      differentKey,
      original: get(original, differentKey),
      change: get(changes, differentKey),
    }),
  )

export default eventDifference
